<p-menu
  #menu1
  [model]="itemsOptions"
  [popup]="true"
  class="custom-menu-more-options"
></p-menu>
<div
  class="w-full flex flex-row justify-between items-center px-[22px] py-4 fixed top-0 left-0 right-0 z-50 bg-white"
>
  <div class="flex flex-row items-center gap-2">
    <div class="nav-mobile-open-trigger">
      <lib-global-button
        [type]="'default'"
        [icon]="'pi pi-bars '"
        (click)="openSidebar($event)"
        onKeyPress=""
      />
    </div>
    @if (loadingLogo()) {
      <p-skeleton
        width="181px"
        height="49.30px"
        class="bg-slate-300 rounded-md max-[540px]:hidden"
      ></p-skeleton>
    } @else {
      <img
        [src]="logoUrl() ?? '../../../../assets/images/brand/logo-nav.svg'"
        alt="Logo"
        class="w-[181px] h-[49.30px] max-[540px]:hidden object-contain"
      />
    }
  </div>

  <p-menu #menu2 [popup]="true" [model]="options" appendTo="body"></p-menu>

  <div class="flex flex-row items-center gap-2">
    <div class="block min-[600px]:hidden">
      <div class="relative inline-flex">
        <lib-global-button
          type="neutral"
          icon="pi pi-bell"
          onKeyPress=""
          (click)="openNotificationSidebar()"
        />
        @if (hasUnread()) {
          <span
            class="absolute top-[-4px] right-[-4px] w-5 h-5 rounded-full bg-error-900 border-2 border-white pointer-events-none"
          ></span>
        }
      </div>
    </div>
    <div class="hidden min-[600px]:block">
      <div class="relative inline-flex">
        <lib-global-button
          type="neutral"
          icon="pi pi-bell"
          onKeyPress=""
          (click)="show($event)"
        />
        @if (hasUnread()) {
          <span
            class="absolute top-[-4px] right-[-4px] w-5 h-5 rounded-full bg-error-900 border-2 border-white pointer-events-none"
          ></span>
        }
      </div>
    </div>
    <p-avatar
      class="h-12 flex items-center"
      icon="pi pi-user"
      shape="circle"
      size="large"
      (click)="menu2.toggle($event)"
      onkeypress=""
    />
  </div>
</div>

@if (currentUserRole() === UserRole.admin) {
  <div
    class="flex flex-wrap fixed bottom-0 left-0 right-0 z-50 bg-neutral-200 py-[9px] px-[25px] justify-between max-[460px]:justify-around max-[460px]:gap-1 max-[372px]:px-[10px]"
  >
    <div
      class="flex flex-col py-[2px] px-1 items-center cursor-pointer"
      [routerLink]="'/admin/institutions'"
    >
      <i class="pi pi-building text-brand-primary"></i>
      <span class="text-label text-brand-primary" i18n>Instituciones</span>
    </div>
    <div
      class="flex flex-col py-[2px] px-1 items-center cursor-pointer"
      [routerLink]="'/admin/users'"
    >
      <i class="pi pi-user text-brand-primary"></i>
      <span class="text-label text-brand-primary" i18n>Usuarios</span>
    </div>
    <div
      class="flex flex-col py-[2px] px-1 items-center cursor-pointer"
      [routerLink]="'/admin/report'"
    >
      <i class="pi pi-chart-line text-brand-primary"></i>
      <span class="text-label text-brand-primary" i18n>Reportes</span>
    </div>
    <div
      class="flex flex-col py-[2px] px-1 items-center cursor-pointer"
      (click)="menu1.toggle($event)"
      onkeypress
    >
      <i class="pi pi-ellipsis-v text-brand-primary"></i>
      <span class="text-label text-brand-primary" i18n>Más</span>
    </div>
  </div>
}

<p-drawer
  [visible]="sidebarVisible"
  (visibleChange)="onDrawerVisibleChange($event)"
  [showCloseIcon]="false"
  [baseZIndex]="20000"
  [autoZIndex]="true"
  [modal]="true"
  [dismissible]="false"
  appendTo="body"
  styleClass="nav-mobile-sidebar"
>
  <ng-template #header>
    @if (loadingLogo()) {
      <p-skeleton
        width="181px"
        height="49.30px"
        class="bg-slate-300 rounded-md"
      ></p-skeleton>
    } @else {
      <img
        [src]="logoUrl() ?? '../../../../assets/images/brand/logo-nav.svg'"
        alt="Logo"
        class="object-contain max-h-[80px] mx-auto"
      />
    }
  </ng-template>

  <ng-template #content>
    <div class="flex flex-col gap-[14px] mt-7">
      @for (link of items; track $index) {
        <lib-menu-item [text]="link.name" [routerRedirect]="link.route" />
      }
    </div>
  </ng-template>
</p-drawer>

<div class="w-full">
  <p-drawer
    [blockScroll]="true"
    [showCloseIcon]="false"
    [(visible)]="showNotification"
    position="bottom"
    styleClass="noti-sidebar"
    (onHide)="onHide()"
  >
    <div class="noti-sidebar-content">
      <app-overlay-notifications />
    </div>
  </p-drawer>
</div>

<div class="min-[600px]:w-[361px]">
  <p-popover #op (onShow)="onShow()" (onHide)="onHide()">
    <app-overlay-notifications />
  </p-popover>
</div>
